import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
export default {
  name: "membership",
  computed: {
    ...userVuex.mapState(["userInfo", "settingInfo", "isLogin", "userCardInfo"]),
    ...taskVuex.mapState(["taskInfo"])
  },
  data() {
    const tabList = [{
      label: "Fan Rights",
      value: 0
    }, {
      label: "VIP",
      value: 1
    }, {
      label: "Props",
      value: 2
    }];
    return {
      tabList,
      selectTab: null
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          await this.initFnc();
        }
      },
      deep: true,
      immediate: true
    },
    "$route.query": {
      handler(query) {
        const map = {
          fan: 0,
          vip: 1,
          props: 2
        };
        const type = query?.type;
        const index = map[type];
        if (index !== undefined) {
          this.selectTab = {
            ...this.tabList[index]
          }; // 替换引用！
        }
      },

      immediate: true
    }
  },
  methods: {
    ...userVuex.mapActions(["getCardPriceInfo", "buyCard", "getUserRights", "buyCardCredits"]),
    async initFnc() {}
  }
};